import React, { Fragment, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate, useLocation } from "react-router-dom";

const Authmiddleware = ({ children }) => {
  const { isLoading, isAuthenticated, loginWithRedirect } = useAuth0();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect({
        appState: { returnTo: location.pathname + location.search },
      });
    }
  }, [isLoading, isAuthenticated, loginWithRedirect, location]);

  if (isLoading) {
    return <div>…Cargando sesión, por favor espera…</div>;
  }

  if (!isAuthenticated) {
    return null;
  }

  return <Fragment>{children}</Fragment>;
};

export default Authmiddleware;
